import WixStudioLogo from '@components/Template/WixStudioLogo';
import { Box, Text } from '@wix/design-system';
import s from './WixStudioBanner.module.scss';
import { Trans } from '@wix/wix-i18n-config';

const WixStudioBanner = () => {
  return (
    <Box className={s.studioBanner}>
      <Text light size="tiny" weight="thin">
        <Trans i18nKey="marketplace.template-page.studio-banner">
          1
          <LogoWithWrapper />3
        </Trans>
      </Text>
    </Box>
  );
};

const LogoWithWrapper = () => {
  return (
    <div className={s.logoWrapper}>
      <WixStudioLogo fillColor="#fff" />
    </div>
  );
};

export default WixStudioBanner;
